import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { PLAN_TYPE } from './modalTypes';
import useCustomGrouping from '../hooks/useCustomGrouping';
import { useAppDispatch } from '../../../hooks';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {
    typeOfPlan: PLAN_TYPE;
    groupToChange: string;
    enablePopupForEndOfPHE: boolean;
    caseNumber: string;
}

export default function OverageAndOtherMemberChangePlan({
    closeModal,
    openModal,
    typeOfPlan,
    groupToChange,
    enablePopupForEndOfPHE,
    caseNumber,
}: IModalProps) {
    const dispatch = useAppDispatch();
    const { addToExistingGroup } = useCustomGrouping({ dispatch });

    function onClose(e) {
        e?.preventDefault();
        closeModal('overageAndOtherMemberChangePlan');
    }

    function onContinue() {
        closeModal('overageAndOtherMemberChangePlan');
        addToExistingGroup(
            {
                typeOfPlan,
                groupToChange,
                isChangePlan: true,
                enablePopupForEndOfPHE,
                caseNumber,
            },
            { openModal },
        );
    }

    return (
        <Modal id="overageAndOtherMemberChangePlanModal">
            <Modal.Header
                id="overageAndOtherMemberChangePlanModalHeader"
                titleId="indportal.customGrouping.customGrouping"
                onHide={onClose}
            />
            <Modal.Body id="overageAndOtherMemberChangePlanModalBody">
                <p>
                    <FormattedMessage id="indportal.customGrouping.error.overageEnrollGroupMember" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="overageAndOtherMemberChangePlanModalCancelButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.cancel" 
                />
                <CapitalizedButton 
                    id="overageAndOtherMemberChangePlanModalContinueButton" 
                    onClickHandler={onContinue} 
                    variant="primary" 
                    labelId="button.continue" 
                    leftMargin={true} 
                />
            </Modal.Controls>
        </Modal>
    );
}
